import React from 'react'

export default function GridList({ children }) {
    return (
        <div className='grid_list'>
            {children}
        </div>
    )
}
